import SelectorComponent from './SelectorComponent';

export default SelectorComponent;
